<template>
  <div class="text-break">
    <div v-if="showProducto" class="font-weight-medium">{{ productoText }}</div>
    <div v-if="showDescripcion" :class="{ 'grey--text text--darken-2': showProducto }">{{ descripcionText }}</div>
    <span v-if="!showProducto && !showDescripcion">-</span>
  </div>
</template>

<script>
//Texto de producto y descripcion de un item en modo lectura (sin truncado). La descripcion va mas suave debajo del producto
export default {
  name: "ItemProductoDescripcion",
  props: {
    producto: { type: String, default: null },
    descripcion: { type: String, default: null },
  },
  computed: {
    productoText() {
      return (this.producto || "").trim();
    },
    descripcionText() {
      return (this.descripcion || "").trim();
    },
    //La descripcion se copia del producto al elegirlo: no se repite
    descripcionIgual() {
      return this.productoText.toLowerCase() === this.descripcionText.toLowerCase();
    },
    showProducto() {
      return this.productoText !== "";
    },
    showDescripcion() {
      return this.descripcionText !== "" && !(this.showProducto && this.descripcionIgual);
    },
  },
};
</script>
